import { OnInit, EventEmitter, ElementRef, } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { CreditCardValidator } from 'angular-cc-library';
import { CardPaymentService } from '../card-payment.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FlashMessagesService } from 'angular2-flash-messages';
import { TournamentService } from 'src/app/tournamentpopup/tournament.service';
import { Store } from '@ngrx/store';
import { UserBalanceData } from '.././../store/actions/appActions';
import { first } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatDialogRef } from '@angular/material/dialog';
import { MainService } from '../../_services/main.service';
var FirstTimeDepositComponent = /** @class */ (function () {
    function FirstTimeDepositComponent(welcomeData, _cardPaymentService, formBuilder, spinner, _flashMessagesService, _tournamentService, store, deviceService, dialogRef, _mainService) {
        var _this = this;
        this.welcomeData = welcomeData;
        this._cardPaymentService = _cardPaymentService;
        this.formBuilder = formBuilder;
        this.spinner = spinner;
        this._flashMessagesService = _flashMessagesService;
        this._tournamentService = _tournamentService;
        this.store = store;
        this.deviceService = deviceService;
        this.dialogRef = dialogRef;
        this._mainService = _mainService;
        this.depositSuccess = new EventEmitter();
        this.ipAddress = '192.168.0.149';
        this.isFormShow = false;
        this.promo_code_validation = { message: '', icon: 'far fa-check-circle', icon_color: '', validate: '', bonus_amount: '' };
        this.awsUploadUrl = environment.assetURL + "/assets/default/images/";
        this.isCheckingPromo = false;
        this.isCheckPromoDis = true;
        this.isDisable = false;
        this.selectedAmt = 25;
        this.store.select('authData').subscribe(function (state) {
            if (state[0]) {
                _this.userData = state[0];
                _this.user_id = _this.userData.id;
            }
        });
        if (welcomeData && welcomeData.status) {
            this.isWelcome = welcomeData.status;
            this.welcomeDataObj = welcomeData;
        }
    }
    Object.defineProperty(FirstTimeDepositComponent.prototype, "f", {
        get: function () {
            return this.addFundForm.controls;
        },
        enumerable: true,
        configurable: true
    });
    FirstTimeDepositComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._mainService.getSetting().subscribe(function (shows) {
            if (shows.status === 'success') {
                var userSettings = shows.entities;
                _this.minDeposit = Number(userSettings["min_deposit"]) || 3;
                _this.maxDeposit = Number(userSettings["max_deposit"]) || 1000;
            }
        }, function (err) {
            console.log(err);
        });
        this.assetsUrl = "" + environment.assetURL;
        this._tournamentService.getIpAddress(this.user_id).subscribe(function (data) {
            if (data.ip)
                _this.ipAddress = data.ip;
        });
        this.addFundForm = this.formBuilder.group({
            selected_package: ['', Validators.required],
            custom_amt: ['', [Validators.pattern("^[0-9]{1,9}(\.[0-9][0-9])?$"), this.customAmountValidator()]],
            promo_code: [''],
            card_number: ['', [CreditCardValidator.validateCCNumber]],
            name: ['', Validators.required],
            expiry: ['', [Validators.maxLength(7), CreditCardValidator.validateExpDate]],
            cvv: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(4)]],
            expiry_date: [''],
            postal_code: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(10)]],
        });
        this.addFunds();
    };
    FirstTimeDepositComponent.prototype.getAmount = function (item) {
        var _this = this;
        this.addFundForm.controls['selected_package'].setValue(item.money);
        if (item !== 'other') {
            this.addFundForm.controls['custom_amt'].setValue(parseFloat(item.money));
        }
        else {
            this.addFundForm.controls['selected_package'].setValue('other');
            var match = this.fundsData.dataList.find(function (item) { return parseFloat(item.money) == _this.f.custom_amt.value; });
            if (match) {
                this.addFundForm.controls['selected_package'].setValue(match.money);
            }
        }
        if (this.f.promo_code.value && ((this.f.custom_amt.value && this.f.custom_amt.value > 0) || (this.f.selected_package.value != 'other' && this.f.selected_package.value))) {
            this.isCheckPromoDis = false;
        }
        else {
            this.isCheckPromoDis = true;
            this.promo_code_validation.icon_color = '';
            this.promo_code_validation.message = '';
        }
        if (!this.isCheckPromoDis && this.f.promo_code.value && (this.f.selected_package.value !== 'other' || (this.f.custom_amt.value !== '' && this.f.custom_amt.value > 0))) {
            this.checkPromoCode("card");
        }
    };
    FirstTimeDepositComponent.prototype.promoCodeDisable = function () {
        if (this.f.promo_code.value && ((this.f.custom_amt.value && this.f.custom_amt.value > 0) || (this.f.selected_package.value != 'other' && this.f.selected_package.value))) {
            this.isCheckPromoDis = false;
        }
        else {
            this.isCheckPromoDis = true;
            this.promo_code_validation.icon = '';
            this.promo_code_validation.message = '';
        }
    };
    FirstTimeDepositComponent.prototype.addFunds = function () {
        var _this = this;
        this.isFormShow = false;
        var userId = this.userData.id || 0;
        this.spinner.show();
        this._cardPaymentService.addFunds(userId).subscribe(function (data) {
            _this.isFormShow = true;
            if (data.status === 'success') {
                _this.fundsData = data.entities;
                if (_this.fundsData.orderCount > 0 && _this.fundsData.isDefault === 'Y') {
                    _this.promo_code_value = '';
                }
                else {
                    _this.promo_code_value = _this.fundsData.promo_code;
                    _this.f['promo_code'].setValue(_this.fundsData.promo_code);
                }
                if (_this.welcomeDataObj && _this.welcomeDataObj.status) {
                    var amount_1 = _this.welcomeDataObj.amount;
                    var match = _this.fundsData.dataList.find(function (item) { return item.money == amount_1; });
                    if (match) {
                        _this.getAmount({ money: amount_1 });
                        _this.f['selected_package'].setValue(amount_1);
                    }
                    else {
                        _this.f['custom_amt'].setValue(amount_1);
                        _this.getAmount('other');
                    }
                    _this.f['promo_code'].setValue(_this.welcomeDataObj.promoCode);
                    if (_this.welcomeDataObj.promoCode)
                        _this.isCheckPromoDis = false;
                }
                else {
                    var amountVal = (_this.fundsData && _this.fundsData.dataList && _this.fundsData.dataList[0] && _this.fundsData.dataList[0].money) ? _this.fundsData.dataList[0].money : _this.selectedAmt;
                    if (amountVal) {
                        _this.f['custom_amt'].setValue(parseFloat(amountVal));
                        _this.getAmount('other');
                    }
                }
            }
            _this.spinner.hide();
        });
    };
    FirstTimeDepositComponent.prototype.customAmountValidator = function () {
        var _this = this;
        return function (control) {
            var value = Number(control.value);
            if (!value)
                return null;
            _this.f.selected_package.setErrors({ required: false });
            if (value < _this.minDeposit) {
                return { minDepositError: true };
            }
            if (value > _this.maxDeposit) {
                return { maxDepositError: true };
            }
            return null;
        };
    };
    FirstTimeDepositComponent.prototype.onSubmit = function () {
        var _this = this;
        this.submitted = true;
        if (this.f.custom_amt.value > 0)
            this.addFundForm.controls['selected_package'].setValue(this.f.selected_package.value);
        if (this.f.custom_amt.value == '' && (this.f.selected_package.value == '' || this.f.selected_package.value == 'other')) {
            this.f.selected_package.setErrors({ required: true });
        }
        if (this.addFundForm.valid) {
            this.isDisable = true;
            var cardExpiryDate = this.f.expiry.value.replace(/ /gi, '');
            var fundData_1 = {
                'user_id': this.user_id,
                'selected_package': 'other',
                'package_amount': this.f.custom_amt.value,
                'promo_code': this.f.promo_code.value,
                'currency': "" + environment.CURRENCY_SYMBOL,
                'ip': this.ipAddress,
                'user_agent': this.deviceService.userAgent,
                'card_number': this.f.card_number.value,
                'name': this.f.name.value,
                'expiry': this.f.expiry.value,
                'expiry_date': cardExpiryDate,
                'cvv': this.f.cvv.value,
                'zip_code': this.f.postal_code.value
            };
            this.spinner.show();
            this._tournamentService.getUserLocation(this.user_id, function (locationData) {
                fundData_1['country'] = locationData['country'];
                fundData_1['state'] = locationData['state'];
                fundData_1['ip'] = locationData['ip'];
                fundData_1['user_dob'] = locationData['user_dob'];
                _this._cardPaymentService.ftpCard(fundData_1).pipe(first()).subscribe(function (data) {
                    if (data.status === 'success') {
                        if (data.total_amount != null) {
                            _this.userData.dollar_balance = parseFloat(_this.userData.dollar_balance) + parseFloat(data.total_amount);
                            _this.store.dispatch(new UserBalanceData(_this.userData.dollar_balance));
                        }
                        var success_message = 'Your payment has been completed and amount added to your wallet.';
                        if (data.message != null)
                            success_message = data.message;
                        _this._flashMessagesService.show(success_message, { cssClass: 'alert-success', timeout: 10000, showCloseBtn: true });
                        _this.addFundForm.reset();
                        _this.depositSuccess.emit({ status: true });
                        _this.promo_code_validation = { message: '', icon: 'far fa-check-circle', icon_color: '', validate: '', bonus_amount: '' };
                        if (_this.welcomeDataObj)
                            _this.dialogRef.close(data);
                    }
                    else {
                        _this.scrollToTop();
                        _this.depositSuccess.emit({ status: false });
                        _this._flashMessagesService.show(data.errorMessage, { cssClass: 'alert-danger', timeout: 10000, showCloseBtn: true });
                    }
                    _this.spinner.hide();
                    _this.submitted = false;
                    _this.isDisable = false;
                }, function (error) {
                    _this.spinner.hide();
                    _this.submitted = false;
                    _this.isDisable = false;
                    console.log(error);
                });
            });
        }
    };
    FirstTimeDepositComponent.prototype.keyPress = function (event) {
        var pattern = /[0-9\+\.\ ]/;
        var inputChar = String.fromCharCode(event.charCode);
        if (event.keyCode !== 8 && !pattern.test(inputChar)) {
            event.preventDefault();
        }
    };
    FirstTimeDepositComponent.prototype.scrollToTop = function () {
        this.addFundFormElement.nativeElement.scrollTop = 0;
    };
    FirstTimeDepositComponent.prototype.checkPromoCode = function (type) {
        var _this = this;
        if (type === 'card') {
            this.promo_code_validation.message = '';
            if (this.f.promo_code.value && (this.f.selected_package.value !== 'other' || (this.f.custom_amt.value !== '' && this.f.custom_amt.value > 2))) {
                this.isCheckingPromo = true;
                var data = { 'user_id': this.user_id, 'selected_package': "other", 'package_amount': this.f.custom_amt.value != 0 ? this.f.custom_amt.value : this.f.selected_package.value, 'promo_code': this.f.promo_code.value };
                this.sub_checkPromoCode = this._cardPaymentService.checkPromoCode(data).subscribe(function (res) {
                    _this.isCheckingPromo = false;
                    if (res.status === 'success') {
                        _this.promo_code_validation.message = res.msg;
                        _this.promo_code_validation.validate = res.validate;
                        _this.promo_code_validation.bonus_amount = res.bonus_amount;
                        if (res.validate === 'yes') {
                            _this.promo_code_validation.icon = 'far fa-check-circle';
                            _this.promo_code_validation.icon_color = '#52a328';
                        }
                        else {
                            _this.promo_code_validation.icon = 'far fa-times-circle';
                            _this.promo_code_validation.icon_color = '#e8132e';
                        }
                    }
                    else {
                        _this.scrollToTop();
                        _this.depositSuccess.emit({ status: false });
                        _this.promo_code_validation.icon = 'far fa-times-circle';
                        _this.promo_code_validation.icon_color = '#e8132e';
                        _this.promo_code_validation.message = '';
                        _this._flashMessagesService.show(res.msg, { cssClass: 'alert-danger', timeout: 5000, showCloseBtn: true });
                    }
                });
            }
            else if (((this.f.selected_package.value === '') && (this.f.custom_amt.value !== '' || this.f.custom_amt.value < 3))) {
                this.scrollToTop();
                this.depositSuccess.emit({ status: false });
                this._flashMessagesService.show("The Charge amount field must contain a number greater than or equal to 3.", { cssClass: 'alert-danger', timeout: 5000, showCloseBtn: true });
            }
        }
        else {
            this.scrollToTop();
            this.depositSuccess.emit({ status: false });
            this._flashMessagesService.show("Promo code is required.", { cssClass: 'alert-danger', timeout: 5000, showCloseBtn: true });
        }
    };
    return FirstTimeDepositComponent;
}());
export { FirstTimeDepositComponent };
